import { Lock } from "lucide-react";

export function PreviewBanner({ runId, label = "Private preview · admins only · G3 pilot", note = "Not visible to students. Only facts checked word-for-word on official sources are shown." }) {
  return (
    <div data-testid="sci-preview-banner" className="border-b border-amber-900/20 bg-amber-50">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-3 gap-y-1 px-6 py-2 text-xs text-amber-900 lg:px-10">
        <Lock className="h-3.5 w-3.5" aria-hidden="true" />
        <span className="font-mono uppercase tracking-wider">{label}</span>
        <span className="text-amber-800/80">{note}</span>
        {runId && <span className="ml-auto font-mono text-[10px] text-amber-800/70" data-testid="sci-preview-run-id">run {runId}</span>}
      </div>
    </div>
  );
}
